import { render, staticRenderFns } from "./Fallback.vue?vue&type=template&id=4bee1b01&scoped=true"
import script from "./Fallback.vue?vue&type=script&lang=js"
export * from "./Fallback.vue?vue&type=script&lang=js"
import style0 from "./Fallback.vue?vue&type=style&index=0&id=4bee1b01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee1b01",
  null
  
)

export default component.exports